import React from 'react';
import { loadLanguage } from 'Utils/jwtUtil';
// Components
import Anchor from 'Components/common/Anchor';

// Actions
import { T } from 'Actions/translate';

class F1OrderItem extends React.Component {
    render() {
        const { item, chooseItem, testid } = this.props;
        let lang = loadLanguage();
        return (
            <Anchor testid={testid} onClickOfSingleTap={ chooseItem }>
                <h6 className="order-num text-ellipsis row"><label>{T('host_fone_order_number')}</label>{ item.number }</h6>
                <p className="F1-num text-ellipsis row"><label>{T('host_fone_e1_order_number')}</label>{ item.eoneNumber }</p>
                <p className="E1-num text-ellipsis row"><label>{T('host_fone_order_status')}</label>{ T(item.eoneStatus) }</p>
                {
                    item.status === 1 && lang !== 'EN' ?
                    <p className="row clearfix">
                        <span className="replenishment-time text-ellipsis pull-left"><label>{T('host_fone_replenishment_date')}</label>{ item.createTime }</span>
                        <span className="replenishment-quantity text-ellipsis pull-right"><label>{T('host_fone_replenishment_amount')}</label>{ item.totalQuantity }</span>
                    </p>
                    : null
                }
                {
                    item.status === 1 && lang === 'EN' ?
                    <p className="row clearfix">
                        <label>{T('host_fone_replenishment_date')}</label>{ item.createTime }
                    </p>
                    : null
                }
                {
                    item.status === 1 && lang === 'EN' ?
                    <p className="row clearfix">
                        <label>{T('host_fone_replenishment_amount')}</label>{ item.totalQuantity }
                    </p>
                    : null
                }
                {
                    item.status === 4 && lang !== 'EN' ?
                    <p className="row clearfix">
                        <span className="receive-time text-ellipsis pull-left"><label>{T('host_fone_receive_date')}</label>{ item.receivedTime }</span>
                        <span className="receive-quantity text-ellipsis pull-right"><label>{T('host_fone_receive_amount')}</label>{ item.receivedQuantity }</span>
                    </p>
                    : null
                }
                {
                    item.status === 4 && lang === 'EN' ?
                    <p className="row clearfix">
                        <label>{T('host_fone_receive_date')}</label>{ item.receivedTime }
                    </p>
                    : null
                }
                {
                    item.status === 4 && lang === 'EN' ?
                    <p className="row clearfix">
                        <label>{T('host_fone_receive_amount')}</label>{ item.receivedQuantity }
                    </p>
                    : null
                }
                {
                    item.status === -1 && lang !== 'EN' ?
                    <p className="row clearfix">
                        <span className="cancel-time text-ellipsis pull-left"><label>{T('host_fone_cancel_date')}</label>{ item.canceledTime }</span>
                        <span className="receive-quantity text-ellipsis pull-right"><label>{T('host_fone_receive_amount')}</label>{ item.receivedQuantity }</span>
                    </p>
                    : null
                }
                {
                    item.status === -1 && lang === 'EN' ?
                    <p className="row clearfix">
                        <label>{T('host_fone_cancel_date')}</label>{ item.canceledTime }
                    </p>
                    : null
                }
                {
                    item.status === -1 && lang === 'EN' ?
                    <p className="row clearfix">
                        <label>{T('host_fone_receive_amount')}</label>{ item.receivedQuantity }
                    </p>
                    : null
                }
            </Anchor>
        );
    }
}

export default F1OrderItem;
